'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Actions = require('../Actions');

var _Actions2 = _interopRequireDefault(_Actions);

var _SimpleButton = require('./generic/SimpleButton');

var _SimpleButton2 = _interopRequireDefault(_SimpleButton);

var _imagePreview = require('../components/generic/image-handling/image-preview');

var _imagePreview2 = _interopRequireDefault(_imagePreview);

var _cartImage = require('../components/generic/image-handling/cart-image');

var _cartImage2 = _interopRequireDefault(_cartImage);

var _itemOptions = require('../components/item-options');

var _itemOptions2 = _interopRequireDefault(_itemOptions);

var _ItemOptionModal = require('./generic/ItemOptionModal');

var _ItemOptionModal2 = _interopRequireDefault(_ItemOptionModal);

var _Utility = require('../utils/Utility');

var Utils = _interopRequireWildcard(_Utility);

var _MainStore = require('../stores/MainStore');

var _MainStore2 = _interopRequireDefault(_MainStore);

var _CardItem = require('./common/CardItem');

var _CardItem2 = _interopRequireDefault(_CardItem);

var _CardItemRow = require('./common/CardItemRow');

var _CardItemRow2 = _interopRequireDefault(_CardItemRow);

var _reactRouterDom = require('react-router-dom');

var _emptyImg = require('../../img/empty-img.png');

var _emptyImg2 = _interopRequireDefault(_emptyImg);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

//wrapper functional component to pass params as props to main file.
function withItemPreviewRouter(Component) {
    function ComponentWithItemPreviewRouter(props) {
        var history = (0, _reactRouterDom.useHistory)();
        var params = (0, _reactRouterDom.useParams)();
        return _react2.default.createElement(Component, _extends({}, props, { history: history, params: params /* other hooks */ }, {
            params: params

        }));
    }
    return ComponentWithItemPreviewRouter;
}

var ItemPreview = function (_React$Component) {
    _inherits(ItemPreview, _React$Component);

    function ItemPreview(props) {
        _classCallCheck(this, ItemPreview);

        var _this = _possibleConstructorReturn(this, (ItemPreview.__proto__ || Object.getPrototypeOf(ItemPreview)).call(this, props));

        _this._isMounted = false;
        _this.targetElement = null;

        _this.changeItemOptionModalTitle = function (title) {
            _this.setState({
                itemOptionModalTitle: title
            });
        };

        _this.state = {
            itemOptionModalTitle: "",
            showItemModal: false,
            itemInCart: "",
            itemDetailObj: {},
            imgURL: "",
            imgAvailable: false
        };

        _this.handleShowModal = _this.handleShowModal.bind(_this);
        _this.handleHideModal = _this.handleHideModal.bind(_this);
        _this.getImageLink = _this.getImageLink.bind(_this);
        _this.addItemToCart = _this.addItemToCart.bind(_this);
        return _this;
    }

    // 2. Initialise your ref and targetElement here


    _createClass(ItemPreview, [{
        key: 'handleHideModal',
        value: function handleHideModal() {
            //hide modal backdrop
            // $('.modal-backdrop').remove();

            // let locationDetails = MainStore.getActiveLocation();

            // let url = '/location/' + locationDetails.objectId;
            // window.history.pushState("", "", url)

            var modalOpen = document.body.classList.contains('modal-open');

            if (modalOpen) {
                document.body.classList.remove("modal-open");
            }

            this.setState({
                showItemModal: false,
                itemDetailObj: {}
            });
        }
    }, {
        key: 'handleShowModal',
        value: function handleShowModal() {
            var self = this;

            // const { history } = this.props;
            // let locId = this.props.params.locId;
            // let itemObjectId = this.props.item.objectId;

            // let url = '/location/'+locId+'/items/'+itemObjectId;
            // window.history.replaceState("", "", url)


            this.setState({
                showItemModal: true,
                itemDetailObj: this.props.item
            });
        }
    }, {
        key: 'componentDidMount',
        value: function componentDidMount() {

            this._isMounted = true;

            // console.log("did mount - item preview")
            //
            // console.log("itemDetailObj")
            // console.log(this.state.itemDetailObj)


            // let locId = this.props.params.locId;
            // let itemId = this.props.params.itemId;

            this.getImageLink(this.props.item);

            // // check the image url exist or image
            // // Its used to show the image on home screen
            // let imageLink = this.getImageLink(this.props.item);
            // this.setItemImage(imageLink);

            // console.log("this.props.item.objectId: " + this.props.item.objectId);

            // if (locId != null && itemId != null){
            //
            //    let schScreenValidation = this.props.loadScheduleScreen;
            //
            //     if (schScreenValidation == false && itemId == this.props.item.objectId){
            //         this.setState({
            //                 view          : { showModal : true },
            //                 itemDetailObj : this.props.item
            //             }
            //         );
            //
            //    }
            // }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            this._isMounted = false;
        }

        // setItemImage(src) {
        //     this.img = new Image();
        //     this.img.onload = () => {
        //         let itemImage = this.getImage(src);
        //         this.setState({itemImage});
        //     };
        //     this.img.onerror = () => {
        //         let captionStyle = {
        //             position : "absolute",
        //             top      : 0
        //         };
        //         let imageAvailable = false;
        //         this.setState({captionStyle, imageAvailable});
        //     };
        //     this.img.src = src;
        // }

    }, {
        key: 'addItemToCart',
        value: function addItemToCart(event) {
            var itemId = this.props.item.objectId;
            var update = this.props.item;
            _Actions2.default.addItemToCart(itemId, update);
        }
    }, {
        key: 'getImageLink',
        value: function getImageLink(itemObj) {
            var _this2 = this;

            // console.log("Load image on did mount")
            if (itemObj.mediaArray && itemObj.mediaArray.length > 0) {
                var link = itemObj.mediaArray[0].url;

                getImageOrFallback(link, "no-image").then(function (result) {

                    if (result == "no-image") {
                        _this2.setState({
                            imgURL: _emptyImg2.default,
                            imgAvailable: false
                        });
                    } else {
                        _this2.setState({
                            imgURL: result,
                            imgAvailable: true
                        });
                    }
                });
            } else {
                // return emptyImg;
                this.setState({
                    imgURL: _emptyImg2.default,
                    imgAvailable: false
                });
            }
        }

        // getImage(link) {
        //
        //         //<img
        //             //src       = {link}
        //             //title     = {this.props.item.itemName}
        //             //className = "group list-group-image"
        //         ///>
        //
        //     return (
        //         <CartImage
        //             link       = {link}
        //             // itemName   = {this.props.item.itemName}
        //             itemName   = {"Item"}
        //             classNames = {"group list-group-image"}
        //         />
        //     );
        // }

    }, {
        key: 'render',


        // getItemOptionModalTitle = (item) => {
        //     const title = this.state.itemOptionModalTitle;
        //      return title ? title : item.groupDetailPointer.groupName;
        // }

        value: function render() {
            // check the location menu is configured as ROW
            var isMenuTypeRowConfig = _MainStore2.default.isMenuTypeRow();

            var itemName = this.props.item.itemName;

            var itemDescription = this.props.item.itemDescription;

            var maxlimit = 150;
            if ($(window).width() < 400) {
                maxlimit = 80;
            }

            var maxlimit1 = 130;
            if ($(window).width() < 400) {
                maxlimit1 = 80;
            }

            var itemOptionModal = _react2.default.createElement(
                _ItemOptionModal2.default,
                {
                    handleHideModal: this.handleHideModal,
                    showModal: this.state.showItemModal
                    // image           = {this.state.itemImage}
                    // title           = {this.getItemOptionModalTitle(this.state.itemDetailObj)}
                },
                _react2.default.createElement(_itemOptions2.default, {
                    itemImageURL: this.state.imgURL,
                    imgAvailable: this.state.imgAvailable,
                    item: this.state.itemDetailObj
                    // itemInCart       = {this.state.itemInCart}
                    // itemInCart       = {this.props.scheduleScreenstore.itemDetailsCart.itemInCart}
                    , handleHideModal: this.handleHideModal,
                    changeTitle: this.changeItemOptionModalTitle,
                    callbackParent: this.props.callbackParent
                    // showScheduleModal = {this.props.showScheduleModal}
                    , history: this.props.history
                    // isResturantOpen  = {this.props.isResturantOpen}
                    // isGroupAvailable = {this.props.isGroupAvailable}
                })
            );

            return _react2.default.createElement(
                _react2.default.Fragment,
                null,
                isMenuTypeRowConfig ? _react2.default.createElement(
                    'div',
                    { className: 'mb-4 col-sm-12 col-md-6 col-lg-6' },
                    _react2.default.createElement(_CardItemRow2.default, {
                        title: itemName,
                        itemImageURL: this.state.imgURL,
                        imageAlt: itemName,
                        imageClassName: 'card-img',
                        subTitle: itemDescription.length > maxlimit ? itemDescription.substring(0, maxlimit - 3) + '...' : itemDescription,
                        price: _.round(this.props.item.itemPrice, 2).toFixed(2),
                        callBackParent: this.handleShowModal
                    })
                ) : _react2.default.createElement(
                    'div',
                    { className: 'mb-4 grid-item col-md-4 col-md-4 col-sm-6' },
                    _react2.default.createElement(_CardItem2.default, {
                        title: itemName,
                        subTitle: itemDescription.length > maxlimit1 ? itemDescription.substring(0, maxlimit1 - 3) + '...' : itemDescription,
                        imageAlt: itemName,
                        itemImageURL: this.state.imgURL,
                        imageClassName: 'img-fluid item-img',
                        price: _.round(this.props.item.itemPrice, 2).toFixed(2),
                        callBackParent: this.handleShowModal
                    })
                ),
                this.state.showItemModal ? itemOptionModal : null
            );
        }
    }]);

    return ItemPreview;
}(_react2.default.Component);

var getImageOrFallback = function getImageOrFallback(path, fallback) {
    return new Promise(function (resolve) {
        var img = new Image();
        img.src = path;
        img.onload = function () {
            return resolve(path);
        };
        img.onerror = function () {
            return resolve(fallback);
        };
    });
};

//create highter order component.
var HOC_ITEM_PREVIEW = withItemPreviewRouter(ItemPreview);

exports.default = HOC_ITEM_PREVIEW;


//////////////////
// WEBPACK FOOTER
// ./src/components/item-preview.jsx
// module id = 474
// module chunks = 0